/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum AddonNames {
    PortalEnums = 'portalEnums',
    PortalFeatures = 'portalFeatures',
    PortalPreferences = 'portalPreferences',
    PortalFilters = 'portalFilters',
}
